"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRawType = getRawType;
exports.isArray = isArray;
exports.isFunction = isFunction;
exports.isNumber = isNumber;
exports.isObject = isObject;
exports.isString = isString;
exports.noop = noop;
exports.only = only;
exports.parseQuery = parseQuery;
exports.getPerformanceData = getPerformanceData;
exports["default"] = void 0;

var _RawTypes = _interopRequireDefault(require("../enum/RawTypes"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * 获取原始类型
 *
 * @example
 * Array => '[object Array]'
 * Number => '[object Number]'
 * Object => '[object Object]'
 * String => '[object String]'
 *
 * @param {*} val
 * @returns {string}
 */
function getRawType(val) {
  return Object.prototype.toString.call(val);
}
/**
 * 判断是否是数组类型
 *
 * @param {*} val
 * @returns {boolean}
 */


function isArray(val) {
  return getRawType(val) === _RawTypes["default"].ARRAY;
}
/**
 * 判断是否是函数类型
 *
 * @param {*} val
 * @returns {boolean}
 */


function isFunction(val) {
  return getRawType(val) === _RawTypes["default"].FUNCTION;
}
/**
 * 判断是否是数值类型
 *
 * @param {*} val
 * @returns {boolean}
 */


function isNumber(val) {
  return getRawType(val) === _RawTypes["default"].NUMBER;
}
/**
 * 判断是否是对象类型
 *
 * @param {*} val
 * @returns {boolean}
 */


function isObject(val) {
  return getRawType(val) === _RawTypes["default"].OBJECT;
}
/**
 * 判断是否是字符类型
 *
 * @param {*} val
 * @returns {boolean}
 */


function isString(val) {
  return getRawType(val) === _RawTypes["default"].STRING;
}
/**
 * 空方法
 */


function noop() {}

;
/**
 * 返回一个包含传入的白名单属性的对象
 *
 * @param {Object} obj - 需要被过滤的对象
 * @param {string|string[]} keys - 属性白名单
 * @returns {Object}
 */

function only() {
  var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var keys = arguments.length > 1 ? arguments[1] : undefined;
  if (!isArray(keys) && !isString(keys)) throw new TypeError('keys must be an array or a string.'); // 兼容传入单个属性的情况

  if (isString(keys)) {
    keys = [keys];
  }

  return keys.reduce(function (ret, key) {
    if (obj[key]) {
      ret[key] = obj[key];
    }

    return ret;
  }, {});
}
/**
 * 解析 URL 的查询参数，返回一个对象
 *
 * @returns {Object}
 */


function parseQuery() {
  var query = {};
  var search = window.location.search;
  if (!search) return query;
  search.replace(/([^?&=])=([^?&=])/g, function replace(match, key, val) {
    query[key] = val;
  });
  return query;
}
/**
 * 获取页面性能相关数据
 *
 * @returns {Object}
 */


function getPerformanceData() {
  var _p = window.performance;
  var timing = _p.timing;

  var entries = _p.getEntriesByType('resource'); // 页面加载资源


  var resources = {}; // 页面加载资源数

  var resourceCount = entries.length;
  entries.forEach(function (entry) {
    // 只上报 CSS、JS 资源耗时
    if (!/\.(css|js)$/ig.test(entry.name)) {
      return;
    } // 资源加载时长，四舍五入取整


    var duration = Math.round(entry.responseEnd - entry.fetchStart); // 从内存加载无需耗时

    var fromMemory = duration === 0; // 从磁盘加载

    var fromDisk = entry.responseStart === entry.requestStart;
    /**
     * 资源从何处加载
     *   - server: 服务器
     *   - memory: 内存
     *   - disk: 磁盘
     */

    var from = 'server';

    if (fromMemory) {
      from = 'memory';
    } else if (fromDisk) {
      from = 'disk';
    }

    var key = "r_".concat(entry.name.slice(entry.name.lastIndexOf('/') + 1));
    resources[key] = "".concat(duration, "|").concat(from, "|").concat(entry.initiatorType);
  });
  return _objectSpread(_objectSpread({
    /**
     * 对用户
     */
    time_page_loaded: timing.loadEventEnd - timing.fetchStart,
    // 统计页面onload时间（页面首次加载性能统计）
    time_page_paint: timing.domInteractive - timing.fetchStart,
    // 统计页面白屏时间
    time_dom_ready: timing.domContentLoadedEventEnd - timing.fetchStart,
    // 用户可操作时间

    /**
     * 对开发
     */
    time_net_request: timing.responseStart - timing.requestStart,
    // 发送请求时间
    time_net_response: timing.responseEnd - timing.responseStart,
    // 请求响应时间
    time_app_ttfb: timing.responseStart - timing.fetchStart,
    // 首字节加载时间
    time_dom_construct: timing.domContentLoadedEventEnd - timing.domInteractive,
    // dom树结构构建完成耗时
    time_dom_loaded: timing.domComplete - timing.domInteractive
  }, resources), {}, {
    // 资源加载明细
    resourceCount: resourceCount // 资源数

  });
}

var _default = {
  getRawType: getRawType,
  isArray: isArray,
  isFunction: isFunction,
  isNumber: isNumber,
  isObject: isObject,
  isString: isString,
  noop: noop,
  only: only,
  parseQuery: parseQuery,
  getPerformanceData: getPerformanceData
};
exports["default"] = _default;